import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { PostForm } from "@/components/posts/PostForm";
import { Skeleton } from "@/components/ui/skeleton";

export default function PostCreatePage() {
    const [sp] = useSearchParams();
    const editId = sp.get("edit");
    const [categories, setCategories] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [editing, setEditing] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        (async () => {
            try {
                const [c, d] = await Promise.all([api.get("/categories"), api.get("/districts")]);
                setCategories(c.data);
                setDistricts(d.data);
                if (editId) {
                    const p = await api.get(`/posts/${editId}`);
                    setEditing(p.data);
                }
            } catch (e) {
                toast.error("Could not load form data");
            } finally {
                setLoading(false);
            }
        })();
    }, [editId]);

    return (
        <div className="space-y-6" data-testid="post-create-page">
            <header>
                <div className="text-sm font-medium text-orange-600">
                    {editing ? "Editing" : "New post"}
                </div>
                <h1 className="mt-1 text-3xl font-extrabold text-neutral-900 sm:text-4xl">
                    {editing ? editing.title : "Create a post"}
                </h1>
                <p className="mt-1 text-sm text-neutral-500">
                    Fill in the details, upload a poster, and publish or send
                    for review.
                </p>
            </header>
            {loading ? (
                <div className="grid gap-4 lg:grid-cols-5">
                    <Skeleton className="h-96 rounded-2xl lg:col-span-3" />
                    <Skeleton className="h-96 rounded-2xl lg:col-span-2" />
                </div>
            ) : (
                <PostForm
                    categories={categories}
                    districts={districts}
                    editing={editing}
                    onSubmitted={(post) => navigate(`/posts/${post.id}`)}
                />
            )}
        </div>
    );
}
